// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1kjg_","title":"AfterBackImages_title__12mVs","images":"AfterBackImages_images__3oOK7"};